'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'immutable';
import { FLINT } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIList from 'UIComponents/list/UIList';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UITextInput from 'UIComponents/input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SUBMISSIONS = 'submissions';
function langKey(key) {
  return `mab.${key}`;
}
function isValid(variation) {
  return variation.get('error').length === 0;
}
export default class MABExperimentModalControlsFields extends Component {
  constructor(...args) {
    super(...args);
    this.getDeletedVariationComponents = (variation, index) => ({
      inputField: /*#__PURE__*/_jsx(UIFormControl, {
        children: /*#__PURE__*/_jsx(UITextInput, {
          className: "text-decoration-line-through",
          value: variation.get('name'),
          readOnly: true,
          style: {
            color: FLINT
          }
        })
      }),
      sideButton: /*#__PURE__*/_jsx(UIIconButton, {
        onClick: (...partialArgs) => this.props.onDeleteVariationUndo(index, ...partialArgs),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('deleteVariationUndo')
        }),
        use: "transparent",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: 'undo'
        })
      })
    });
    this.getNewVariationComponents = (variation, index) => {
      const {
        onDeleteVariation,
        onVariationNameChange,
        variations
      } = this.props;
      return {
        inputField: /*#__PURE__*/_jsx(UIFormControl, {
          error: !isValid(variation),
          validationMessage: this.renderVariationValidationMessage(variation),
          children: /*#__PURE__*/_jsx(UITextInput, {
            onChange: (...partialArgs) => onVariationNameChange(index, ...partialArgs),
            value: variation.get('name')
          })
        }),
        sideButton: variations.size > 1 && /*#__PURE__*/_jsx(UIIconButton, {
          onClick: (...partialArgs) => onDeleteVariation(index, ...partialArgs),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('deleteVariation')
          }),
          use: "transparent",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: 'delete'
          })
        })
      };
    };
    this.getVariationComponents = (variation, index) => variation.get('deleted') ? this.getDeletedVariationComponents(variation, index) : this.getNewVariationComponents(variation, index);
    this.renderNewVariation = (variation, index) => {
      if (this.props.mabExperimentIsStarted) {
        return /*#__PURE__*/_jsx("span", {
          children: variation.get('name')
        }, index);
      }
      const {
        inputField,
        sideButton
      } = this.getVariationComponents(variation, index);
      return /*#__PURE__*/_jsx(UIMediaObject, {
        itemRight: sideButton,
        children: inputField
      }, index);
    };
  }
  getShowAddVariationButton() {
    const {
      maxVariations,
      variations,
      mabExperimentIsStarted
    } = this.props;
    if (mabExperimentIsStarted) {
      return false;
    }
    const variationCount = variations.filter(variation => !variation.get('deleted')).size;
    return variationCount < maxVariations - 1;
  }
  renderAddVariationButton() {
    if (!this.getShowAddVariationButton()) {
      return null;
    }
    return /*#__PURE__*/_jsxs(UIButton, {
      onClick: this.props.onAddVariation,
      use: "link",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: 'add'
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('buttons.addVariation')
      })]
    }, "addVariationButton");
  }
  renderMasterVariationName() {
    const {
      masterVariationName,
      onMasterVariationNameChange,
      mabExperimentIsStarted
    } = this.props;
    return /*#__PURE__*/_jsx(UIFormControl, {
      error: masterVariationName.length === 0,
      validationMessage: this.renderMasterVariationValidationMessage(),
      children: mabExperimentIsStarted ? /*#__PURE__*/_jsx("span", {
        children: masterVariationName
      }) : /*#__PURE__*/_jsx(UITextInput, {
        onChange: onMasterVariationNameChange,
        value: masterVariationName
      })
    }, "masterVariation");
  }
  renderMetric() {
    return /*#__PURE__*/_jsxs("div", {
      className: "p-bottom-3",
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        className: "m-bottom-1",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('metric.label')
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('metric.tooltip')
        }),
        children: /*#__PURE__*/_jsx("span", {
          className: "m-bottom-1",
          style: {
            fontWeight: 500
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey(`metrics.${SUBMISSIONS}`)
          })
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey(`metric.description.${SUBMISSIONS}`)
      })]
    });
  }
  renderVariations() {
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('variationFields')
      }),
      children: /*#__PURE__*/_jsxs(UIList, {
        childClassName: "m-bottom-2",
        children: [this.renderMasterVariationName(), this.props.variations.map(this.renderNewVariation), this.renderAddVariationButton()]
      })
    });
  }
  renderMasterVariationValidationMessage() {
    const {
      masterVariationName
    } = this.props;
    return masterVariationName.length === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('validationErrorMessage.emptyMasterVariationName')
    }) : null;
  }
  renderVariationValidationMessage(variation) {
    if (isValid(variation)) {
      return null;
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey(`validationErrorMessage.${variation.get('error')}`)
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(UIForm, {
      children: [this.renderMetric(), this.renderVariations()]
    });
  }
}
MABExperimentModalControlsFields.propTypes = {
  masterVariationName: PropTypes.string.isRequired,
  maxVariations: PropTypes.number.isRequired,
  onAddVariation: PropTypes.func.isRequired,
  onDeleteVariation: PropTypes.func.isRequired,
  onDeleteVariationUndo: PropTypes.func,
  onMasterVariationNameChange: PropTypes.func.isRequired,
  onVariationNameChange: PropTypes.func.isRequired,
  variations: PropTypes.instanceOf(List).isRequired,
  mabExperimentIsStarted: PropTypes.bool.isRequired
};